import { render, staticRenderFns } from "./conversation.vue?vue&type=template&id=4306138a&scoped=true&"
import script from "./conversation.vue?vue&type=script&lang=js&"
export * from "./conversation.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("../../assets/css/conversation.css?vue&type=style&index=0&id=4306138a&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4306138a",
  "14699b3c"
  
)

export default component.exports